import { PlatformDependencies } from '@citrite/workspace-ui-platform';
import { container } from 'Workspace/DependencyManagement';
import { TrimmedKeyMap } from 'Workspace/UserContext/trimmedKeyMap';
import { getUpnFromOnPremUserDetails } from 'Workspace/UserContext/upnUtil';

class UpnHandlerForNativeAADFlow {
	private currentUserName: string;
	private userToUpnMap: TrimmedKeyMap<string> = new TrimmedKeyMap<string>();

	public setCurrentUserName(userName: string) {
		this.currentUserName = userName;
	}

	public getCurrentUserName(): string {
		return this.currentUserName;
	}

	public setUserToUpnMapping(userName: string, upn: string) {
		this.userToUpnMap.set(userName, upn);
	}

	public waitForValidUserName(timeoutMs = 4000): Promise<boolean> {
		return new Promise(resolve => {
			const maxAttempts = timeoutMs / 100;
			let attempts = 0;
			const checkUserName = () => {
				if (this.currentUserName?.trim().length > 0) {
					resolve(true);
				} else if (attempts >= maxAttempts) {
					resolve(false);
				} else {
					attempts++;
					setTimeout(checkUserName, 100);
				}
			};
			checkUserName();
		});
	}

	public async getUpnForCurrentUser(): Promise<string> {
		try {
			const isValidUserName = await this.waitForValidUserName();

			if (!isValidUserName) {
				return '';
			}
			//Try to get UPN from map first
			const upnFromMap = this.userToUpnMap.get(this.currentUserName);

			if (upnFromMap?.trim().length > 0) {
				return upnFromMap;
			}

			// Else fetch UPN from user details endpoint
			const wsConfig = container
				.resolve(PlatformDependencies.WorkspaceConfiguration)
				.get();
			const getUserDetailsURL = wsConfig?.authManager?.getUserDetailsURL;
			const upnDetails = await getUpnFromOnPremUserDetails(getUserDetailsURL);
			return upnDetails.upn;
		} catch (e) {
			return '';
		}
	}
}

export const upnHandlerForNativeFlow = new UpnHandlerForNativeAADFlow();
